import { ComboboxContent } from "@datamole/wds-component-combobox";
import styled from "styled-components";

export const MultiSelectContent = styled(ComboboxContent)`
    z-index: ${({ theme }) => theme.zIndex.dropdown};
`;
